export const CURRENCIES = [
  { code: 'COP', locale: 'es-CO', symbol: '$' },
  { code: 'USD', locale: 'en-US', symbol: '$' },
  { code: 'EUR', locale: 'de-DE', symbol: '€' },
  { code: 'BRL', locale: 'pt-BR', symbol: 'R$' },
  { code: 'GBP', locale: 'en-GB', symbol: '£' },
];

// Maps i18n locale → default currency for that region
const CURRENCY_BY_LOCALE = {
  'es-CO': { code: 'COP', locale: 'es-CO', symbol: '$' },
  'es_CO': { code: 'COP', locale: 'es-CO', symbol: '$' },
  'es':    { code: 'COP', locale: 'es-CO', symbol: '$' },
  'en-US': { code: 'USD', locale: 'en-US', symbol: '$' },
  'en_US': { code: 'USD', locale: 'en-US', symbol: '$' },
  'en':    { code: 'USD', locale: 'en-US', symbol: '$' },
  'en-GB': { code: 'GBP', locale: 'en-GB', symbol: '£' },
  'en_GB': { code: 'GBP', locale: 'en-GB', symbol: '£' },
  'de-DE': { code: 'EUR', locale: 'de-DE', symbol: '€' },
  'de_DE': { code: 'EUR', locale: 'de-DE', symbol: '€' },
  'de':    { code: 'EUR', locale: 'de-DE', symbol: '€' },
  'fr-FR': { code: 'EUR', locale: 'fr-FR', symbol: '€' },
  'fr_FR': { code: 'EUR', locale: 'fr-FR', symbol: '€' },
  'fr':    { code: 'EUR', locale: 'fr-FR', symbol: '€' },
  'es-ES': { code: 'EUR', locale: 'es-ES', symbol: '€' },
  'es_ES': { code: 'EUR', locale: 'es-ES', symbol: '€' },
  'pt-PT': { code: 'EUR', locale: 'pt-PT', symbol: '€' },
  'pt_PT': { code: 'EUR', locale: 'pt-PT', symbol: '€' },
  'pt-BR': { code: 'BRL', locale: 'pt-BR', symbol: 'R$' },
  'pt_BR': { code: 'BRL', locale: 'pt-BR', symbol: 'R$' },
};

export const DEFAULT_CURRENCY = { code: 'USD', locale: 'en-US', symbol: '$' };

export const getCurrencyForLocale = locale =>
  CURRENCY_BY_LOCALE[locale] || DEFAULT_CURRENCY;

export const getCurrencyByCode = code =>
  CURRENCIES.find(c => c.code === code) || DEFAULT_CURRENCY;
